<script>
/* eslint-disable no-undef */
import { cloneDeep } from 'lodash-es'

export default {
    name: 'WeeklyNav',

    props: {
        bottomNav: {
            type: Boolean,
            default: false
        },
        dataSet: {
            type: Object,
            required: true
        }
    },

    computed: {
        navWeekRangeFormat() {
            return this.dateFormatWeekRange(this.dataSet.navWeekStart)
        }
    },

    methods: {
        startWithinWeekOrAfter() {
            const weekStartBefore = cloneDeep(this.dataSet.navWeekStart)
            weekStartBefore.subtract(7, 'days')

            const weekEndBefore = cloneDeep(weekStartBefore)
            weekEndBefore.add(6, 'd').startOf('day')

            const _start = moment(this.dataSet.navDateRange.start)
            const _between = _start.isBetween(weekStartBefore, weekEndBefore, undefined, '[]')
            const _sameOrAfter = weekStartBefore.isSameOrAfter(_start)

            return _between || _sameOrAfter
        },

        endWithinWeekOrBefore() {
            const weekStartAfter = cloneDeep(this.dataSet.navWeekStart)
            weekStartAfter.add(7, 'days')

            const weekEndAfter = cloneDeep(weekStartAfter)
            weekEndAfter.add(6, 'd').startOf('day')

            const _end = moment(this.dataSet.navDateRange.end)
            const _between = _end.isBetween(weekStartAfter, weekEndAfter, undefined, '[]')
            const _sameOrBefore = weekEndAfter.isSameOrBefore(_end)

            return _between || _sameOrBefore
        },

        navigate(payload) {
            switch (payload) {
            case 'week-before':
                if ( this.startWithinWeekOrAfter()  ) {
                    this.$emit('navigate', payload)
                }
                break
            case 'week-after':
                if ( this.endWithinWeekOrBefore() ) {
                    this.$emit('navigate', payload)
                }
                break
            default:
                console.error('unknown case in weekly nav navigate: ', payload)
            }
            if ( this.bottomNav ) {
                this.$scrollTo(document.body)
            }
        }
    }
}
</script>

<template>
    <div class="calendar-subnav d-flex py-4">
        <div class="outer d-flex">
            <button
                class="nav-left no-btn"
                :class="{
                    'active' : startWithinWeekOrAfter()
                }"
                tabindex="0"
                @click="navigate('week-before')"
            >
                <svg class="icon icon-cal-subnav-left">
                    <use xlink:href="#cal-subnav-left" />
                </svg>
            </button>
            <div class="nav-center weekly px-sm-5 text-center text-uppercase">
                {{ navWeekRangeFormat }}
            </div>
            <button
                class="nav-right no-btn"
                :class="{
                    'active' : endWithinWeekOrBefore()
                }"
                tabindex="0"
                @click="navigate('week-after')"
            >
                <svg class="icon icon-cal-subnav-right">
                    <use xlink:href="#cal-subnav-right" />
                </svg>
            </button>
        </div>
    </div>
</template>
